<template>
    <div v-if="model" class="normal-container py-5">
        <h1 id="anchor" class="text-center">Start Saving Money Today!</h1>
        <h2 class="text-primary text-center mb-3">Create An Account</h2>
        <div class="text-secondary text-center row">
            <router-link
                :to="{
                    name: addMessagingRouting + 'auth.login',
                    hash: '#top-anchor',
                }"
                class="col"
            >
                Already Have A Visitor Account?
            </router-link>
        </div>

        <div class="text-secondary text-center row">
            <router-link
                :to="{
                    name: addMessagingRouting + 'auth.forgotten-password',
                    hash: '#top-anchor',
                }"
                class="col mb-4"
            >
                Forgot Login Info?
            </router-link>
        </div>

        <div class="row">
            <div class="col-lg-10 offset-lg-1">
                <form @submit.prevent="submit">
                    <div class="row">
                        <div class="col-md-auto text-center mb-2">
                            <img
                                src="@/assets/images/icon-num-1.png"
                                alt=""
                                class="img-fluid icon-nums-size"
                            />
                        </div>

                        <div class="col-md">
                            <div class="form-group">
                                <div class="input-group mb-3">
                                    <input
                                        v-model="model.email"
                                        type="email"
                                        :class="[
                                            arrayExists(validationErrors.email)
                                                ? 'is-invalid'
                                                : '',
                                            'form-control',
                                        ]"
                                        placeholder="Email Address *"
                                    />

                                    <div
                                        v-for="(
                                            err, idx
                                        ) in validationErrors.email"
                                        :key="idx"
                                        :class="[invalidClasses]"
                                    >
                                        {{ err }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <input
                                    v-model="model.password"
                                    type="password"
                                    :class="[
                                        arrayExists(validationErrors.password)
                                            ? 'is-invalid'
                                            : '',
                                        'form-control',
                                    ]"
                                    placeholder="Password * (at least 10 digits long)"
                                />
                            </div>

                            <div class="form-group">
                                <input
                                    v-model="model.password_confirmation"
                                    type="password"
                                    :class="[
                                        arrayExists(validationErrors.password)
                                            ? 'is-invalid'
                                            : '',
                                        'form-control',
                                    ]"
                                    placeholder="Confirm Password *"
                                />

                                <div
                                    v-for="(
                                        err, idx
                                    ) in validationErrors.password"
                                    :key="idx"
                                    :class="[invalidClasses]"
                                >
                                    {{ err }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <h2 class="text-primary text-center">Profile</h2>

                    <div class="row mb-3">
                        <div class="col-md-auto text-center mb-2">
                            <img
                                src="@/assets/images/icon-num-2.png"
                                alt=""
                                class="img-fluid icon-nums-size"
                            />
                        </div>

                        <div class="col-md">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input
                                            v-model="model.first_name"
                                            type="text"
                                            :class="[
                                                arrayExists(
                                                    validationErrors.first_name
                                                )
                                                    ? 'is-invalid'
                                                    : '',
                                                'form-control',
                                            ]"
                                            placeholder="First Name *"
                                        />

                                        <div
                                            v-for="(
                                                err, idx
                                            ) in validationErrors.first_name"
                                            :key="idx"
                                            :class="[invalidClasses]"
                                        >
                                            {{ err }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input
                                            v-model="model.last_name"
                                            type="text"
                                            :class="[
                                                arrayExists(
                                                    validationErrors.last_name
                                                )
                                                    ? 'is-invalid'
                                                    : '',
                                                'form-control',
                                            ]"
                                            placeholder="Last Name *"
                                        />

                                        <div
                                            v-for="(
                                                err, idx
                                            ) in validationErrors.last_name"
                                            :key="idx"
                                            :class="[invalidClasses]"
                                        >
                                            {{ err }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <VueDatePicker
                                            id="dob"
                                            v-model="model.mem_birth"
                                            no-header
                                            :bootstrap-styling="true"
                                            class="input-group form-control pt-1 pl-1"
                                            :visible-years-number="100"
                                            :max-date="Date.now()"
                                            format="D MMMM YYYY"
                                            placeholder="Date of Birth"
                                            @on-open="
                                                () =>
                                                    (isDatePickerOpen =
                                                        !isDatePickerOpen)
                                            "
                                        >
                                        </VueDatePicker>

                                        <div
                                            v-if="
                                                arrayExists(
                                                    validationErrors.mem_birth
                                                )
                                            "
                                            class="alert alert-danger w-100 mt-2"
                                            role="alert"
                                        >
                                            <p
                                                v-for="(
                                                    error, index
                                                ) in validationErrors.mem_birth"
                                                :key="index"
                                                class="mb-0 dob-font-size"
                                            >
                                                {{ error }}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input
                                            v-model="model.phone"
                                            v-mask="'(###) ###-####'"
                                            type="text"
                                            :class="[
                                                arrayExists(
                                                    validationErrors.phone
                                                )
                                                    ? 'is-invalid'
                                                    : '',
                                                'form-control',
                                            ]"
                                            placeholder="Mobile Phone *"
                                        />

                                        <div
                                            v-for="(
                                                err, idx
                                            ) in validationErrors.phone"
                                            :key="idx"
                                            :class="[invalidClasses]"
                                        >
                                            {{ err }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="form-group">
                                        <input
                                            v-model="model.addr_1"
                                            type="text"
                                            :class="[
                                                arrayExists(
                                                    validationErrors.addr_1
                                                )
                                                    ? 'is-invalid'
                                                    : '',
                                                'form-control',
                                            ]"
                                            placeholder="Street Address *"
                                        />

                                        <div
                                            v-for="(
                                                err, idx
                                            ) in validationErrors.addr_1"
                                            :key="idx"
                                            :class="[invalidClasses]"
                                        >
                                            {{ err }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input
                                            v-model="model.city"
                                            type="text"
                                            :class="[
                                                arrayExists(
                                                    validationErrors.city
                                                )
                                                    ? 'is-invalid'
                                                    : '',
                                                'form-control',
                                            ]"
                                            placeholder="City *"
                                        />

                                        <div
                                            v-for="(
                                                err, idx
                                            ) in validationErrors.city"
                                            :key="idx"
                                            :class="[invalidClasses]"
                                        >
                                            {{ err }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <select
                                            id="state"
                                            v-model="model.state"
                                            :class="[
                                                arrayExists(
                                                    validationErrors.state
                                                )
                                                    ? 'is-invalid'
                                                    : '',
                                                'custom-select',
                                            ]"
                                        >
                                            <option value="" selected disabled>
                                                Select a State, Province, or
                                                Region *
                                            </option>

                                            <option
                                                v-for="state in states"
                                                :key="state.id"
                                                :value="state.abbrev"
                                            >
                                                {{ state.name }}
                                            </option>
                                        </select>

                                        <div
                                            v-for="(
                                                err, idx
                                            ) in validationErrors.state"
                                            :key="idx"
                                            :class="[invalidClasses]"
                                        >
                                            {{ err }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input
                                            v-model="model.zip"
                                            type="text"
                                            maxlength="10"
                                            :class="[
                                                arrayExists(
                                                    validationErrors.zip
                                                )
                                                    ? 'is-invalid'
                                                    : '',
                                                'form-control',
                                            ]"
                                            placeholder="Zip/Postal Code *"
                                        />

                                        <div
                                            v-for="(
                                                err, idx
                                            ) in validationErrors.zip"
                                            :key="idx"
                                            :class="[invalidClasses]"
                                        >
                                            {{ err }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <select
                                            id="country"
                                            v-model="model.country"
                                            :class="[
                                                arrayExists(
                                                    validationErrors.country
                                                )
                                                    ? 'is-invalid'
                                                    : '',
                                                'custom-select',
                                            ]"
                                        >
                                            <option value="" selected disabled>
                                                Select a Country *
                                            </option>
                                            <option
                                                v-for="country in countries"
                                                :key="country.ordinal"
                                                :value="country.iso"
                                            >
                                                {{ country.printable_name }}
                                            </option>
                                        </select>

                                        <div
                                            v-for="(
                                                err, idx
                                            ) in validationErrors.country"
                                            :key="idx"
                                            :class="[invalidClasses]"
                                        >
                                            {{ err }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <p class="very-small">
                                *Denotes Required information
                            </p>

                            <FacilitySelection
                                :facilities="filteredFacilities"
                                :model="model"
                                @preferred-facility="
                                    (value) =>
                                        (model.preferred_facility = value)
                                "
                            ></FacilitySelection>

                            <div class="custom-control custom-checkbox">
                                <input
                                    id="notify-me-checkbox"
                                    v-model="model.notify_me"
                                    :class="[
                                        arrayExists(validationErrors.notify_me)
                                            ? 'is-invalid'
                                            : '',
                                        'custom-control-input',
                                    ]"
                                    type="checkbox"
                                />
                                <label
                                    class="custom-control-label pt-1 pt-md-0"
                                    for="notify-me-checkbox"
                                >
                                    Send me offers from iWebVisit.com via email
                                    or text.
                                </label>

                                <div
                                    v-for="(
                                        err, idx
                                    ) in validationErrors.notify_me"
                                    :key="idx"
                                    :class="[invalidClasses]"
                                >
                                    {{ err }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <h2 class="text-primary text-center mt-5 mb-3">
                        Confirmation/Security
                    </h2>

                    <div class="row">
                        <div class="col-md-auto text-center mb-2">
                            <img
                                src="@/assets/images/icon-num-3.png"
                                alt=""
                                class="img-fluid icon-nums-size"
                            />
                        </div>

                        <SmsOptIn
                            :model="model"
                            :phone="model.phone"
                            :is-creating="true"
                            :is-special-number="
                                model.phone && model.phone === '(777) 555-3333'
                            "
                            @can-receive-sms="
                                (x) => (model.can_receive_sms = x)
                            "
                        ></SmsOptIn>
                    </div>

                    <div class="row text-center">
                        <div class="col-md-4 offset-md-6 w-50 mx-auto my-4">
                            <vue-recaptcha
                                ref="recaptcha"
                                :sitekey="getKey"
                                size="invisible"
                                @verify="onRecaptchaVerified"
                                @expired="onRecaptchaExpired"
                            ></vue-recaptcha>
                            <button
                                type="submit"
                                :disabled="!hasOptedIn || isSubmitting"
                                class="btn btn-primary btn-lg"
                            >
                                <i
                                    v-if="isSubmitting"
                                    class="fas fa-circle-notch fa-spin"
                                ></i>
                                {{
                                    isSubmitting
                                        ? 'Submitting'
                                        : 'Create Account'
                                }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { VueDatePicker } from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import { mapActions, mapGetters, mapState } from 'vuex';
import { errorHandling } from '@/mixins/error-handling';
import { notify } from '@/mixins/notify';
import SmsOptIn from '@/components/Account/SmsOptIn';
import VueRecaptcha from 'vue-recaptcha';
import { routing } from '@/mixins/routing';
import FacilitySelection from '@/components/Account/FacilitySelection.vue';

export default {
    components: { FacilitySelection, SmsOptIn, VueDatePicker, VueRecaptcha },
    mixins: [errorHandling, notify, routing],
    data() {
        return {
            model: {
                state: '',
                country: '',
                preferred_facility: '',
                notify_me: true,
                verification_type: 'sms',
                day_phone_type: 'MOBILE',
                can_receive_sms: false,
                phone: '',
            },
            invalidClasses: 'invalid-feedback alert alert-danger mt-2 mb-0',
            isDatePickerOpen: false,
            isSubmitting: false,
        };
    },
    computed: {
        ...mapState('Facility', ['facilities']),
        ...mapGetters('Facility', ['isFacilitiesLoaded']),
        ...mapState('Support', ['countries', 'states']),
        ...mapGetters('Support', ['isCountriesLoaded', 'isStatesLoaded']),

        hasOptedIn() {
            return this.model.can_receive_sms;
        },
        getKey() {
            return process.env.VUE_APP_RECAPTCHA_SITE_KEY;
        },
        filteredFacilities() {
            if (this.isFacilitiesLoaded && this.isMessagingApp) {
                return this.facilities.filter(
                    (f) => f.is_messaging_app_enabled
                );
            } else if (this.isFacilitiesLoaded) {
                return this.facilities;
            } else {
                return [];
            }
        },
    },
    mounted() {
        this.facilitiesRequest();

        if (!this.isCountriesLoaded) {
            this.countriesRequest();
        }

        if (!this.isStatesLoaded) {
            this.statesRequest();
        }
    },
    methods: {
        ...mapActions('Auth', ['registerRequest']),
        ...mapActions('Facility', ['facilitiesRequest']),
        ...mapActions('Support', ['countriesRequest', 'statesRequest']),

        submit() {
            this.$refs.recaptcha.execute();
        },
        register(token) {
            this.model.recaptcha_token = token;

            return this.registerRequest(this.model)
                .then(() => {
                    this.$router.push({
                        name: this.addMessagingRouting + 'verify-account',
                    });
                })
                .catch((err) => {
                    this.$refs.recaptcha.reset();
                    this.notify(this.handleError(err));
                })
                .finally(() => (this.isSubmitting = false));
        },
        onRecaptchaVerified(recaptchaToken) {
            this.isSubmitting = true;
            this.$refs.recaptcha.reset();
            this.register(recaptchaToken);
        },
        onRecaptchaExpired() {
            this.$refs.recaptcha.reset();
        },
        onFocusDate() {
            setTimeout(() => {
                if (!this.isDatePickerOpen) {
                    document.getElementById('date').click();
                }
            }, 100);
        },
    },
};
</script>
